module.exports = __webpack_public_path__ + "img/questionnaire.dc08edcf.png";